// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Added Comment Lines'
// Modified Date : 22-09-2025

import { docodeHexResponse } from '../../_common/common.utils';
import CashTransactionTypes from './common-transaction.types';

const INITIAL_STATE = {
	// ADD CASH TRANSACTION DETAILS RESPONSE
	addCashTransactionDetailsResponse: null,
	// UPDATE CASH TRANSACTION RESPONSE
	updateCashTransactionDetailsResponse: null,
	// GET CASH TRANSACTION RESPONSE
	getCashTransactionListResponse: null,
	getCashTransactionListArr: [],
	// FETCH CASH TRANSACTION DETAILS RESPONSE
	fetchCashTransactionDetailsResponse: null,
	fetchCashTransactionDetailsArr: [],
	// DELETE CASH TRANSACTION DETAILS RESPONSE
	deleteCashTransactionDetailsResponse: null,
	// GET COMPANY FINANCE ACCOUNT TYPE LIST RESPONSE
	getCompanyFinanceAccountTypeListResponse: null,
	getCompanyFinanceAccountTypeListArr: [],
	// GET ACCOUNT DAY BOOK RESPONSE
	getAccountDayBookResponse: null,
	getAccountDayBookArr: [],
	// GET VOUCHER COUNT BASED ON COMPANY RESPONSE
	getVoucherCountBasedOnCompanyResponse: null,
	getVoucherCountBasedOnCompanyArr: [],
	// CHECK BRANCH EOD DONE RESPONSE
	checkBranchEODDoneResponse: null,
	checkBranchEODDoneArr: [],
	// GET PARTICULAR CASH TRANSACTION LIST RESPONSE
	getParticularCashTransactionListResponse: null,
	getParticularCashTransactionListArr: [],
	// UPDATE SELECTED TRANSACTION IS APPROVE RESPONSE
	updateSelectedTransactionIsApproveResponse: null,
	// GET VALUES MODAL RESPONSE
	getValuesModalResponse: null,
	getValuesModalArr: [],
	// GET ACCOUNT DAY BOOK FOR ACCOUNT RESPONSE
	getAccountDayBookForAccountResponse: null,
	getAccountDayBookForAccountArr: [],
};

const cashTransactionReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD CASH TRANSACTION DETAILS START *********************** */
		case CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, addCashTransactionDetailsResponse: action.payload };

		case CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_FAILURE:
			return { ...state, addCashTransactionDetailsResponse: action.payload };

		case CashTransactionTypes.ADD_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, addCashTransactionDetailsResponse: null };
		/** ***************** ADD CASH TRANSACTION DETAILS END *********************** */

		/** ***************** UPDATE CASH TRANSACTION DETAILS START *********************** */
		case CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, updateCashTransactionDetailsResponse: action.payload };
		case CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_FAILURE:
			return { ...state, updateCashTransactionDetailsResponse: action.payload };
		case CashTransactionTypes.UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateCashTransactionDetailsResponse: null };
		/** ***************** UPDATE CASH TRANSACTION DETAILS END *********************** */

		// /** ***************** GET CASH TRANSACTION LIST START *********************** */
		case CashTransactionTypes.GET_CASH_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				getCashTransactionListResponse: action.payload,
				getCashTransactionListArr: docodeHexResponse(
					action.payload,
					'GetCompanyTranscationEntryListKey',
				),
			};
		case CashTransactionTypes.GET_CASH_TRANSACTION_LIST_FAILURE:
			return {
				...state,
				getCashTransactionListResponse: action.payload,
				getCashTransactionListArr: [],
			};
		case CashTransactionTypes.GET_CASH_TRANSACTION_LIST_RESPONSE_CHANGED:
			return { ...state, getCashTransactionListResponse: null };
		/** ***************** GET CASH TRANSACTION LIST END *********************** */

		/** ***************** FETCH CASH TRANSACTION DETAILS START *********************** */
		case CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_SUCCESS:
			return {
				...state,
				fetchCashTransactionDetailsResponse: action.payload,
				fetchCashTransactionDetailsArr: docodeHexResponse(
					action.payload,
					'FetchCashTransactionDetailsKey',
				),
			};
		case CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_FAILURE:
			return { ...state, fetchCashTransactionDetailsResponse: action.payload };
		case CashTransactionTypes.FETCH_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchCashTransactionDetailsResponse: null };
		/** ***************** FETCH CASH TRANSACTION DETAILS END *********************** */

		/** ***************** DELETE CASH TRANSACTION DETAILS START *********************** */
		case CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_SUCCESS:
			return { ...state, deleteCashTransactionDetailsResponse: action.payload };
		case CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_FAILURE:
			return { ...state, deleteCashTransactionDetailsResponse: action.payload };
		case CashTransactionTypes.DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteCashTransactionDetailsResponse: null };
		/** ***************** DELETE CASH TRANSACTION DETAILS END *********************** */

		/*** GET COMPANY FINANCE ACCOUNT TYPE LIST START ***/
		case CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_SUCCESS:
			return {
				...state,
				getCompanyFinanceAccountTypeListResponse: action.payload,
				getCompanyFinanceAccountTypeListArr: docodeHexResponse(
					action.payload,
					'FetchCompanyFinanceAccountTypeListKey',
				),
			};
		case CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_FAILURE:
			return { ...state, getCompanyFinanceAccountTypeListResponse: action.payload };
		case CashTransactionTypes.GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_CHANGED:
			return { ...state, getCompanyFinanceAccountTypeListResponse: null };
		/*** GET COMPANY FINANCE ACCOUNT TYPE LIST END ***/

		/******** GET ACCOUNT DAY BOKK START ********* */
		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_SUCCESS:
			return {
				...state,
				getAccountDayBookResponse: action.payload,
				getAccountDayBookArr: docodeHexResponse(
					action.payload,
					'getExistAccountDayBookKey',
				),
			};
		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_FAILURE:
			return { ...state, getAccountDayBookResponse: action.payload };
		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_CHANGED:
			return { ...state, getAccountDayBookResponse: action.payload };
		/******** GET ACCOUNT DAY BOKK END ********* */

		/********  GET VOUCHER COUNT BASED ON COMPANY START  ********* */
		case CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS:
			return {
				...state,
				getVoucherCountBasedOnCompanyResponse: action.payload,
				getVoucherCountBasedOnCompanyArr: docodeHexResponse(
					action.payload,
					'GetCompanyVoucherCountBasedOnCompanyKey',
				),
			};

		case CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE:
			return {
				...state,
				getVoucherCountBasedOnCompanyResponse: action.payload,
				getVoucherCountBasedOnCompanyArr: [],
			};

		case CashTransactionTypes.GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED:
			return {
				...state,
				getVoucherCountBasedOnCompanyResponse: null,
			};
		/********  GET VOUCHER COUNT BASED ON COMPANY END  ********* */

		/********  CHECK BRANCH EOD DONE START  ********* */
		case CashTransactionTypes.CHECK_BRANCH_EOD_DONE_SUCCESS:
			return {
				...state,
				checkBranchEODDoneResponse: action.payload,
				checkBranchEODDoneArr: docodeHexResponse(
					action.payload,
					'GetParticularBranchEODListKey',
				),
			};

		case CashTransactionTypes.CHECK_BRANCH_EOD_DONE_FAILURE:
			return {
				...state,
				checkBranchEODDoneResponse: action.payload,
				checkBranchEODDoneArr: [],
			};

		case CashTransactionTypes.CHECK_BRANCH_EOD_DONE_RESPONSE_CHANGED:
			return {
				...state,
				checkBranchEODDoneResponse: null,
			};
		/********  CHECK BRANCH EOD DONE END  ********* */

		/********  GET PARTICULAR CASH TRANSACTION LIST LIST START  ********* */

		case CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_SUCCESS:
			return {
				...state,
				getParticularCashTransactionListResponse: action.payload,
				getParticularCashTransactionListArr: docodeHexResponse(
					action.payload,
					'particulerBranchAccountKey',
				),
			};
		case CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_FAILURE:
			return {
				...state,
				getParticularCashTransactionListResponse: action.payload,
				getParticularCashTransactionListArr: [],
			};
		case CashTransactionTypes.GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getParticularCashTransactionListResponse: null,
			};
		/********  GET PARTICULAR CASH TRANSACTION LIST LIST END  ********* */

		/********  UPDATE SELECTED TRANSACTION IS APPROVE START  ********* */

		case CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_SUCCESS:
			return {
				...state,
				updateSelectedTransactionIsApproveResponse: action.payload,
			};

		case CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_FAILURE:
			return {
				...state,
				updateSelectedTransactionIsApproveResponse: action.payload,
			};

		case CashTransactionTypes.UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_CHANGED:
			return {
				...state,
				updateSelectedTransactionIsApproveResponse: null,
			};
		/********  UPDATE SELECTED TRANSACTION IS APPROVE END  ********* */

		/********  GET VALUES MODAL START  ********* */
		case CashTransactionTypes.GET_VALUES_MODAL_SUCCESS:
			return {
				...state,
				getValuesModalResponse: action.payload,
				getValuesModalArr: docodeHexResponse(action.payload, 'GetModalValuesKey'),
			};

		case CashTransactionTypes.GET_VALUES_MODAL_FAILURE:
			return {
				...state,
				getValuesModalResponse: action.payload,
				getValuesModalArr: [],
			};

		case CashTransactionTypes.GET_VALUES_MODAL_RESPONSE_CHANGED:
			return {
				...state,
				getValuesModalResponse: null,
			};
		/********  GET VALUES MODAL END  ********* */

		/********  GET ACCOUNT DAY BOOK FOR ACCOUNT START  ********* */
		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_SUCCESS:
			return {
				...state,
				getAccountDayBookForAccountResponse: action.payload,
				getAccountDayBookForAccountArr: docodeHexResponse(
					action.payload,
					'getExistAccountDayBookForAccountKey', // Use the correct key your API uses
				),
			};

		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_FAILURE:
			return {
				...state,
				getAccountDayBookForAccountResponse: action.payload,
				getAccountDayBookForAccountArr: [],
			};

		case CashTransactionTypes.GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_RESET:
			return {
				...state,
				getAccountDayBookForAccountResponse: null,
				getAccountDayBookForAccountArr: [],
			};
		/********  GET ACCOUNT DAY BOOK FOR ACCOUNT END  ********* */

		default:
			return state;
	}
};
export default cashTransactionReducer;
